import { Group } from 'src/design/atoms/Group';
import { Progress } from 'src/design/atoms/Progress';
import { Stack } from 'src/design/atoms/Stack';
import { Text } from 'src/design/atoms/Text';
import { Tooltip } from 'src/design/atoms/Tooltip';
import React from 'react';
import { ChatUsageDto } from 'src/api/FiretrolApiClient';

export interface IUsageMeterProps {
  usage: ChatUsageDto | null;
}

/**
 * Slim daily-usage meter shown in the chat footer, mirroring the Claude platform usage bar.
 * @registry Compact progress bar showing today's chat token usage vs. daily budget; renders nothing when usage is null.
 */
export const UsageMeter = React.memo<IUsageMeterProps>(({ usage }) => {
  if (!usage) return null;

  const total = usage.inputTokens + usage.outputTokens;
  const pct =
    usage.dailyTokenBudget > 0
      ? Math.min(100, (total / usage.dailyTokenBudget) * 100)
      : 0;

  return (
    <Tooltip
      label={`${total.toLocaleString()} of ${usage.dailyTokenBudget.toLocaleString()} tokens used today`}
    >
      <Stack gap={2} style={{ flex: 1, minWidth: 0 }} data-testid="usage-meter">
        <Group justify="space-between">
          <Text size="xs" c="dimmed">
            Daily usage
          </Text>
          <Text size="xs" c="dimmed">
            {Math.round(pct)}%
          </Text>
        </Group>
        <Progress
          value={pct}
          size="sm"
          radius="xl"
          color={usage.withinBudget ? 'blue' : 'red'}
        />
      </Stack>
    </Tooltip>
  );
});
